import UserProfileComponent from './UserProfileComponent';
import DisableUserForm from './Forms/DisableUserForm';

export default class AdvancedTools extends UserProfileComponent {
    templateId() {
        return '#disableUserTemplate';
    }

    form() {
        return new DisableUserForm(this.loader);
    }

    load(containerId) {
        $(containerId).unbind('load.rendered').on('load.rendered', $.proxy(function () {
            $(containerId).find('.toggleUser').click($.proxy(function () {
                this.loadModal(containerId);
            }, this));
        }, this));
        super.load(containerId);
    }

    data() {
        return '/dashboard/profile/ajax/getDisableUser';
    }
}
